import { render } from "./or-admin-product-constructor.vue?vue&type=template&id=08e90d96&scoped=true&bindings={\"options\":\"props\",\"items\":\"data\",\"delete_item\":\"options\",\"move_up\":\"options\",\"move_down\":\"options\",\"add_text\":\"options\",\"add_image\":\"options\",\"add_table\":\"options\"}"
import script from "./or-admin-product-constructor.vue?vue&type=script&lang=js"
export * from "./or-admin-product-constructor.vue?vue&type=script&lang=js"

import "./or-admin-product-constructor.vue?vue&type=style&index=0&id=08e90d96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08e90d96"

export default script